import { useAtomValue } from "@effect/atom-react"
import { useRef } from "react"
import { AsciiSunCanvas } from "./AsciiSunCanvas.tsx"
import { sunScene } from "./gpu/SunScene.ts"
import { useGpuScene } from "./gpu/useGpuScene.ts"
import { reducedMotion, webgpuSupported } from "./state/atoms.ts"

/** The Sun: a fixed, full-viewport background the page scrolls over. */
export function Sun() {
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const supported = useAtomValue(webgpuSupported)
  const reduced = useAtomValue(reducedMotion)
  const animate = supported && !reduced
  const status = useGpuScene(canvasRef, sunScene, animate)
  const live = animate && status !== "failed"

  return (
    <div className="sky" data-status={status} data-live={live}>
      {live ? (
        <canvas ref={canvasRef} className="sun" aria-hidden="true" />
      ) : (
        <AsciiSunCanvas animate={!reduced} />
      )}
    </div>
  )
}
